import logger from '../../services/logger';

import { PageTitle } from "../common/Header"; 

import React, {useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../../css/entretienproduct.css";

import { Button } from "react-bootstrap"; 
import { useNavigate,useLocation } from 'react-router-dom';

//import Navigation from "../navigation";
//import Header from "../common/Header";

const ActionSelect = () => {
    const location = useLocation();
    const { state } = location|| {}; // S'assurer que state est un objet si location.state est null;
    const { product } = state|| {}; // S'assurer que state n'est pas null avant de déstructurer
    logger.log("appareil reçu ",product);

   const navigate = useNavigate();
  
  useEffect(() => {
    logger.log('Dans inventaire des produits');
  }, []); // Le tableau vide en second paramètre signifie que useEffect s'exécutera une fois après le montage initial

  const handleClicktoGive = () => {
    // Rediriger vers la page CardDetail et passer l'objet maintenanceCard
    navigate(`/secondlife/give`,{ state: { product } });
  };

  const handleClicktoSell = () => {
    // Rediriger vers la page CardDetail et passer l'objet maintenanceCard
    navigate(`/secondlife/sell`,{ state: { product } });
  };

  const handleClicktoRecycle = () => {
    // Rediriger vers la page CardDetail et passer l'objet maintenanceCard
    navigate(`/secondlife/recycle`,{ state: { product } });
  };
  
  return (
    <div>
       <PageTitle title={`Deuxième vie : ${product.prod_name}`} />
        
        <div className="row m-0 g-3">
          <div className="col-12 col-md-6 col-lg-4">
            <div className="yellow-background p-4 mt-3 d-flex flex-column h-100">
              <p style={{ fontSize: "1rem", fontWeight: "400", lineHeight: "2"  }} align="center">
                Envisagez de donner votre appareil via une association agréée pour maximiser son impact positif.
                 <br/>Ce geste écologique non seulement aide ceux qui en ont besoin, mais contribue également à la
                préservation de notre environnement.
              </p>
              <Button
                className="mt-auto w-50 mx-auto d-block"
                onClick={() => handleClicktoGive(product)}
              >
                Je donne
              </Button>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4 d-none d-lg-block">
            <div className="p-3 mt-3 d-flex flex-column h-100 bg-white">
               <p style={{ fontSize: "1rem", fontWeight: "400", lineHeight: "2"  }} align="center">
                Revendez votre appareil pour un double bénéfice : économique pour vous et écologique pour la planète.
                 <br/>Cela permet de prolonger la vie utile de l'appareil et de réduire les déchets, contribuant ainsi à un
                environnement plus sain.
              </p>
              <Button
                className="mt-auto w-50 mx-auto d-block"
                onClick={() => handleClicktoSell(product)}
              >
                Je vends
              </Button>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4 d-block d-lg-none">
            <div className="p-3 mt-3 d-flex flex-column h-100 green-border">
               <p style={{ fontSize: "1rem", fontWeight: "400", lineHeight: "2"  }} align="center">
                Revendez votre appareil pour un double bénéfice : économique pour vous et écologique pour la planète.
                 <br/>Cela permet de prolonger la vie utile de l'appareil et de réduire les déchets, contribuant ainsi à un
                environnement plus sain.
              </p>
              <Button
                className="mt-auto w-50 mx-auto d-block"
                onClick={() => handleClicktoSell(product)}
              >
                Je vends
              </Button>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="dark-green-background p-3 mt-3 d-flex flex-column h-100">   
              <p style={{ fontSize: "1rem", fontWeight: "400", lineHeight: "2", color: "white" }} align="center">
                Le recyclage joue un rôle crucial dans la protection de notre environnement en réduisant la quantité
                de déchets, en économisant les ressources naturelles et en diminuant la pollution, contribuant ainsi
                à un avenir plus durable.
              </p>
              <Button
                className="mt-auto w-50 mx-auto d-block"
                onClick={() => handleClicktoRecycle(product)}
              >
                Je recycle
              </Button>
            </div>
          </div>
           <br/>
        </div>
        
       <br/> <br/>
   
       
    </div>
  );
};

export default ActionSelect;